export const NAV_BADGE_LAYER_ID = 'nav - icons';
export const ROUTE_START_MARKER_ID = 'startMarker';
export const ROUTE_END_MARKER_PREFIX = 'endMarker-';
export const getRouteEndMarkerId = (index: number) => `${ROUTE_END_MARKER_PREFIX}${index}`;
